export function removeHtmlTags(html) {
    let div = document.createElement("div");
    div.innerHTML = html;
    let text = div.textContent || div.innerText || "";
    return text;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/utils/removeHtmlTags.ts